module.exports = __webpack_public_path__ + "img/ico7.6590c4ce.svg";